import { useMemo } from "react";
import { ThemeProvider } from "@mui/material";
import initTheme from "./initTheme";
import { useAppTheme } from "../AppTheme";

export function MUIThemeProvider({ children }) {
    const { theme: mode } = useAppTheme();

    const theme = useMemo(() => initTheme(mode), [mode]);

    return <ThemeProvider theme={theme}>{children}</ThemeProvider>;
}
